// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__d6Hb5","wrap":"Notification_wrap__QrI-y","content":"Notification_content__f8K6F","dateTime":"Notification_dateTime__e7XLy"};